var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCorrect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5bbc81",
    d: "M12.641 10.61a56 56 0 0 0-2.748 3.463 45 45 0 0 0-1.266 1.822L5.18 11.84a1.29 1.29 0 0 0-1.643-.231c-.566.36-.7 1.078-.323 1.616L7.55 19.36c.108.153.27.307.458.41.242.154.512.231.78.231.513 0 1.078-.257 1.32-.693.243-.41 1.456-2.54 2.264-3.694a50 50 0 0 1 2.478-3.387 45 45 0 0 1 2.748-3.208c.943-1.026 1.966-2.078 2.99-2.976l.027-.025a1.125 1.125 0 0 0 .08-1.617 1.25 1.25 0 0 0-1.723-.103 52 52 0 0 0-3.287 3.054 44 44 0 0 0-3.044 3.258"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrect);
export default __webpack_public_path__ + "static/media/icon-correct.37ff002962f4811a21e60203691d6bbf.svg";
export { ForwardRef as ReactComponent };